import { Directive } from '@angular/core';
import { BaseForm } from '@components/base-form.abstract';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface Modal {
  closeBtnLabel?: string;
  dismissBtnLabel?: string;
  title: string;
  isCloseDisabled?: boolean;
  isDismissDisabled?: boolean;
  isReadonly?: boolean;
  onClose: (arg?: any) => void;
  onDismiss: (arg?: any) => void;
}

@Directive({})
export class ModalBase extends BaseForm implements Modal {
  closeBtnLabel?: string;
  dismissBtnLabel?: string;
  title: string;
  isCloseDisabled = false;
  isReadonly = false;
  onClose: (arg?: any) => void = this.close;
  onDismiss: (arg?: any) => void = this.dismiss;

  constructor(readonly activeModal?: NgbActiveModal) {
    super();
  }

  close(reason?: any): void {
    this.activeModal.close(reason);
  }

  dismiss(reason?: any): void {
    this.activeModal.dismiss(reason);
  }
}
